/** Visit every recorded point, even when two timestamps display the same minute.
 * 1× is a route preview: thirty recorded seconds take half a second on screen.
 * Unobserved gaps are shortened without creating extra recorded positions. */
export function routePlaybackStep(points,index,speed=1){
 if(!Number.isInteger(index)||index<0||index>=points.length-1)return null;
 const multiplier=[.5,1,2,4].includes(speed)?speed:1,nextIndex=index+1;
 const gap=Date.parse(points[nextIndex].receivedAt)-Date.parse(points[index].receivedAt);
 return {nextIndex,delayMs:points[nextIndex].connectFromPrevious&&Number.isFinite(gap)&&gap>0
  ?Math.max(400/multiplier,Math.min(2000,gap/(60*multiplier))):500/multiplier};
}
// Geometry enrichment replaces objects but not the recorded route membership.
export function routePlaybackIdentity(deviceId,route){
 return `${deviceId??''}:${route?.startAt??''}:${route?.endAt??''}:${route?.snapshotId??''}`;
}
